export enum ActionStatus {
  DRAFT = 'action-draft',
  PENDING = 'action-pending',
  OPEN = 'action-open',
  IN_PROGRESS = 'action-in-progress',
  TO_BE_APPROVED = 'action-to-be-approved',
  COMPLETED = 'action-completed',
  DISCARDED = 'action-discarded',
}

export const ActionStatusNotActionable = [
  ActionStatus.COMPLETED,
  ActionStatus.DISCARDED,
  ActionStatus.PENDING,
];
